import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



  const cardData = {


  keyword: "Best Cab Service in Pune",

  headingDescription: "Trustline Cab provides one of the best cab services in Pune with safe, comfortable, and affordable transportation for local travel, airport transfers, railway station pickups, corporate travel, sightseeing, and outstation journeys. Whether you need a one-way taxi, round-trip cab, hourly rental, or full-day car hire, our experienced chauffeurs ensure punctual pickups and a hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, well-maintained cars, and 24/7 customer support, Trustline Travels is the trusted choice for reliable cab services in Pune.",

  topPlaces: [
    {
      title: "Lonavala",
      description: "Lonavala is one of the most popular weekend getaways from Pune, famous for lush green valleys, waterfalls, Tiger Point, Bhushi Dam, and pleasant weather."
    },
    {
      title: "Matheran",
      description: "Matheran is Asia's only automobile-free hill station, offering scenic viewpoints, toy train rides, dense forests, and a peaceful atmosphere."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a beautiful coastal destination known for clean beaches, sea forts, water sports, seafood, and relaxing weekend holidays."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a renowned hill station featuring strawberry farms, Venna Lake, breathtaking viewpoints, and cool mountain weather throughout the year."
    },
    {
      title: "Shirdi",
      description: "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the sacred Shri Sai Baba Temple."
    },
    {
      title: "Nashik",
      description: "Nashik is famous for its vineyards, wineries, ancient temples, and the holy Godavari River, making it ideal for spiritual and leisure trips."
    },
    {
      title: "Goa",
      description: "Goa is India's favorite beach destination, offering golden beaches, vibrant nightlife, Portuguese heritage, water sports, and luxury resorts."
    },
    {
      title: "Aurangabad",
      description: "Aurangabad is home to the UNESCO-listed Ajanta and Ellora Caves, Bibi Ka Maqbara, and several magnificent historical monuments."
    },
    {
      title: "Kolhapur",
      description: "Kolhapur is well known for the Mahalakshmi Temple, historic forts, authentic Maharashtrian cuisine, and rich cultural heritage."
    },
    {
      title: "Ganpatipule",
      description: "Ganpatipule is a scenic Konkan beach destination famous for its pristine shoreline, ancient Ganpati Temple, and peaceful seaside atmosphere."
    }
  ],






"services": [
{
"name": "Best Cab Service Pune to Mumbai",
"description": "Book the best cab service Pune to Mumbai for one-way trips, round trips, airport transfers, corporate travel, and family journeys. Travel in clean AC Sedan, Ertiga, Innova Crysta, and SUV vehicles with professional chauffeurs, transparent pricing, doorstep pickup, 24x7 customer support, and a safe, comfortable travel experience."
},
{
"name": "Best Outstation Cab Service in Pune",
"description": "Choose the best outstation cab service in Pune for travel to Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Lonavala, Kolhapur, and other destinations. Enjoy affordable fares, experienced drivers, well-maintained vehicles, and flexible one-way or round-trip booking options."
},
{
"name": "Best Taxi Service in Pune",
"description": "Hire the best taxi service in Pune for airport transfers, railway station pickup, local travel, corporate transportation, sightseeing tours, and outstation journeys. Get reliable service, sanitized AC vehicles, verified drivers, and competitive pricing."
},
{
"name": "Best Cab Service from Mumbai Airport to Pune",
"description": "Book the best cab service from Mumbai Airport to Pune with flight tracking, on-time pickup, spacious luggage space, experienced chauffeurs, and comfortable Sedan, Ertiga, Innova Crysta, and SUV vehicles available 24x7."
},
{
"name": "Best Cab Service Mumbai to Pune",
"description": "Travel with the best cab service Mumbai to Pune offering one-way, round-trip, airport transfer, and corporate travel options. Enjoy transparent fares, professional drivers, clean vehicles, and hassle-free online booking."
},
{
"name": "Best Cab Service from Pune to Mumbai Airport",
"description": "Hire the best cab service from Pune to Mumbai Airport for timely airport drop with reliable drivers, comfortable AC cars, flight schedule support, and affordable pricing for business and family travel."
},
{
"name": "Best Mumbai Pune Cab Service",
"description": "Choose the best Mumbai Pune cab service for reliable intercity travel with professional chauffeurs, premium vehicles, one-way and round-trip packages, airport transfers, and 24x7 customer assistance."
},
{
"name": "Best Pune to Mumbai Cab Service",
"description": "Book the best Pune to Mumbai cab service for safe, comfortable, and affordable travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles. Enjoy punctual pickup, transparent pricing, and premium chauffeur-driven transportation."
},
{
"name": "Trustline Cab Service",
"description": "Trustline Cab Service offers reliable local, airport, and outstation taxi services with verified drivers, clean AC vehicles, affordable fares, instant booking confirmation, and dependable customer support for every journey."
},
{
"name": "Trustline Pune Mumbai Cab",
"description": "Book Trustline Pune Mumbai Cab for convenient one-way and round-trip travel with experienced chauffeurs, comfortable vehicles, transparent pricing, and doorstep pickup for business and leisure trips."
},
{
"name": "Trustline Mumbai Pune Cab",
"description": "Choose Trustline Mumbai Pune Cab for reliable return journeys, airport transfers, family travel, and corporate transportation with premium vehicles and professional drivers available around the clock."
},
{
"name": "Trustline Outstation Cabs",
"description": "Trustline Outstation Cabs provide safe and comfortable travel from Pune to destinations across Maharashtra and India with Sedan, Ertiga, Innova Crysta, and SUV options, transparent fares, and experienced chauffeurs."
},
{
"name": "Pune to Mumbai Cab",
"description": "Book Pune to Mumbai cab for one-way, round-trip, airport transfers, business travel, family vacations, and weekend trips with clean AC vehicles, experienced drivers, affordable fares, and instant online booking."
},
{
"name": "Pune to Mumbai Taxi",
"description": "Hire Pune to Mumbai taxi with professional chauffeurs, well-maintained vehicles, and flexible travel options including airport pickup, drop service, one-way cabs, and round-trip bookings at competitive prices."
},
{
"name": "Pune Mumbai Cab Booking",
"description": "Complete Pune Mumbai cab booking online with instant confirmation, transparent pricing, multiple vehicle options, and reliable chauffeur-driven transportation for airport and outstation travel."
},
{
"name": "Pune to Mumbai One Way Cab",
"description": "Book Pune to Mumbai one way cab for affordable single-side travel without return charges. Enjoy comfortable AC vehicles, professional drivers, and convenient pickup from your doorstep."
},
{
"name": "Pune to Mumbai Round Trip Cab",
"description": "Choose Pune to Mumbai round trip cab for business meetings, family vacations, sightseeing, and return travel with flexible packages, experienced chauffeurs, and premium vehicles."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Reserve Pune to Mumbai Airport cab for timely airport pickup and drop with flight monitoring, spacious luggage capacity, verified drivers, and comfortable long-distance travel."
},
{
"name": "Pune to Mumbai Cab Service",
"description": "Reliable Pune to Mumbai cab service offering Sedan, Ertiga, Innova Crysta, and SUV vehicles for one-way, round-trip, airport transfers, corporate travel, and family journeys with transparent pricing."
},
{
"name": "Best Pune to Mumbai Cab",
"description": "Choose the best Pune to Mumbai cab for premium travel with affordable fares, luxury vehicles, experienced chauffeurs, doorstep pickup, and 24x7 booking support."
},
{
"name": "Affordable Pune to Mumbai Cab",
"description": "Book affordable Pune to Mumbai cab with budget-friendly fares, comfortable AC vehicles, reliable drivers, and safe transportation for airport transfers, business trips, and family travel."
},
{
"name": "Luxury Pune to Mumbai Cab",
"description": "Hire luxury Pune to Mumbai cab with premium Innova Crysta and SUV vehicles for corporate executives, VIP guests, family vacations, airport transfers, and comfortable long-distance travel."
},
{
"name": "Innova Cab Pune to Mumbai",
"description": "Book Innova Cab Pune to Mumbai for spacious and comfortable travel with professional chauffeurs, ideal for families, business groups, airport transfers, and outstation journeys."
},
{
"name": "Ertiga Cab Pune to Mumbai",
"description": "Hire Ertiga Cab Pune to Mumbai for affordable 6 to 7 seater travel with ample luggage space, experienced drivers, and convenient one-way or round-trip transportation."
},
{
"name": "Sedan Cab Pune to Mumbai",
"description": "Choose Sedan Cab Pune to Mumbai for economical travel with Swift Dzire, Etios, Aura, and similar AC cars offering comfortable rides, professional drivers, and transparent pricing."
},
{
"name": "Pune to Mumbai Drop Taxi",
"description": "Book Pune to Mumbai drop taxi for hassle-free one-way transportation with doorstep pickup, punctual service, clean vehicles, and affordable taxi fares."
},
{
"name": "Pune to Mumbai Car Rental",
"description": "Hire Pune to Mumbai car rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for airport transfers, corporate travel, family tours, and outstation trips."
},
{
"name": "Cab Service in Pimpri Chinchwad",
"description": "Book Cab Service in Pimpri Chinchwad for local rides, airport transfers, Pune to Mumbai cabs, and outstation travel with affordable pricing, professional drivers, and comfortable AC vehicles."
},
{
"name": "Cab Service in Hinjewadi",
"description": "Choose Cab Service in Hinjewadi for IT employees, airport pickups, Mumbai transfers, business travel, and outstation taxi booking with reliable drivers and premium vehicles."
},
{
"name": "Cab Service in Baner",
"description": "Hire Cab Service in Baner for airport transfers, local taxi booking, Pune to Mumbai cabs, family travel, and corporate transportation with transparent fares and professional chauffeurs."
},
{
"name": "Cab Service in Wakad",
"description": "Book Cab Service in Wakad for one-way and round-trip taxi services, airport transfers, local travel, and outstation journeys with clean AC vehicles and experienced drivers."
},
{
"name": "Cab Service in Kharadi",
"description": "Reliable Cab Service in Kharadi for airport pickup and drop, corporate travel, Pune to Mumbai cabs, local rides, and chauffeur-driven outstation transportation."
},
{
"name": "Cab Service in Hadapsar",
"description": "Book Cab Service in Hadapsar for business travel, airport cabs, Mumbai transfers, family tours, and outstation taxi services with safe, reliable, and affordable transportation."
},
{
"name": "Cab Service in Viman Nagar",
"description": "Choose Cab Service in Viman Nagar for Pune Airport transfers, corporate travel, Mumbai airport drops, local rides, and outstation journeys with premium AC vehicles."
},
{
"name": "Cab Service in Kothrud",
"description": "Hire Cab Service in Kothrud for airport pickup, city travel, Mumbai cabs, sightseeing tours, and outstation trips with verified drivers and affordable pricing."
},
{
"name": "Cab Service in Aundh",
"description": "Book Cab Service in Aundh for airport transportation, business travel, local taxi services, and Pune to Mumbai cab booking with experienced chauffeurs and clean vehicles."
},
{
"name": "Cab Service in Nigdi",
"description": "Reliable Cab Service in Nigdi offering local travel, airport pickup and drop, Pune to Mumbai one-way cabs, and outstation taxi services with transparent fares."
},
{
"name": "Cab Service in Chinchwad",
"description": "Book Cab Service in Chinchwad for local taxi booking, airport transfers, corporate travel, and comfortable outstation journeys with professional drivers and well-maintained vehicles."
},
{
"name": "Cab Service in Bavdhan",
"description": "Choose Cab Service in Bavdhan for affordable local rides, Pune Airport cabs, Mumbai transfers, and outstation travel with reliable chauffeur-driven vehicles."
},
{
"name": "Cab Service in Bhosari",
"description": "Hire Cab Service in Bhosari for industrial visits, airport transfers, railway station pickups, Pune to Mumbai travel, and outstation taxi services with comfortable AC vehicles and experienced drivers."
}
],

"tableData": [
["Best Cab Service Pune to Mumbai", "Best Outstation Cab Service in Pune"],
["Best Taxi Service in Pune", "Best Cab Service from Mumbai Airport to Pune"],
["Best Cab Service Mumbai to Pune", "Best Cab Service from Pune to Mumbai Airport"],
["Best Mumbai Pune Cab Service", "Best Pune to Mumbai Cab Service"],
["Trustline Cab Service", "Trustline Pune Mumbai Cab"],
["Trustline Mumbai Pune Cab", "Trustline Outstation Cabs"],
["Pune to Mumbai Cab", "Pune to Mumbai Taxi"],
["Pune Mumbai Cab Booking", "Pune to Mumbai One Way Cab"],
["Pune to Mumbai Round Trip Cab", "Pune to Mumbai Airport Cab"],
["Pune to Mumbai Cab Service", "Best Pune to Mumbai Cab"],
["Affordable Pune to Mumbai Cab", "Luxury Pune to Mumbai Cab"],
["Innova Cab Pune to Mumbai", "Ertiga Cab Pune to Mumbai"],
["Sedan Cab Pune to Mumbai", "Pune to Mumbai Drop Taxi"],
["Pune to Mumbai Car Rental", "Cab Service in Pimpri Chinchwad"],
["Cab Service in Hinjewadi", "Cab Service in Baner"],
["Cab Service in Wakad", "Cab Service in Kharadi"],
["Cab Service in Hadapsar", "Cab Service in Viman Nagar"],
["Cab Service in Kothrud", "Cab Service in Aundh"],
["Cab Service in Nigdi", "Cab Service in Chinchwad"],
["Cab Service in Bavdhan", "Cab Service in Bhosari"]
],





whychoose: [
  {
    WhyChooseheading: "Best Cab Service in Pune for Every Journey",
    WhyChoosedescription: "Trustline Cab provides reliable cab services in Pune for local travel, airport transfers, corporate travel, and outstation trips with complete convenience."
  },
  {
    WhyChooseheading: "Verified Drivers & Safe Travel",
    WhyChoosedescription: "Our experienced and background-verified chauffeurs ensure every journey is safe, comfortable, and professionally managed."
  },
  {
    WhyChooseheading: "Transparent Fare Policy",
    WhyChoosedescription: "We offer competitive cab fares with upfront pricing, detailed quotations, and absolutely no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Book your cab anytime for early morning airport transfers, late-night travel, business meetings, or emergency trips."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers, all regularly serviced for maximum comfort."
  },
  {
    WhyChooseheading: "Local, Airport & Outstation Services",
    WhyChoosedescription: "We provide flexible transportation solutions for city rides, Pune Airport, Mumbai Airport, sightseeing, and outstation destinations."
  },
  {
    WhyChooseheading: "Customized Travel Solutions",
    WhyChoosedescription: "Whether it's a one-way trip, round trip, corporate booking, or family vacation, we have travel plans to suit every requirement."
  },
  {
    WhyChooseheading: "Quick Booking with Dedicated Support",
    WhyChoosedescription: "Receive instant fare estimates, immediate booking confirmation, and responsive customer support throughout your journey."
  }
]

};

const faqData = [
  {
    question: "Why is Trustline Travels considered one of the best cab services in Pune?",
    answer: "Trustline Travels is trusted for its professional drivers, clean vehicles, transparent pricing, punctual service, and reliable local and outstation cab solutions."
  },
  {
    question: "Do you provide local cab services within Pune?",
    answer: "Yes, we offer local cab services for shopping, office travel, business meetings, sightseeing, and daily transportation across Pune."
  },
  {
    question: "Can I book airport cabs from Pune?",
    answer: "Yes, we provide timely airport pickup and drop services for both Pune Airport and Mumbai Airport."
  },
  {
    question: "Which vehicles are available for booking?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for all types of travel requirements."
  },
  {
    question: "Do you provide one-way and round-trip cab services?",
    answer: "Yes, Trustline Travels offers both one-way and round-trip cab bookings for local and outstation travel."
  },
  {
    question: "Are your cab fares transparent?",
    answer: "Yes, we provide clear fare quotations before booking with no hidden charges."
  },
  {
    question: "Is your cab service available 24/7?",
    answer: "Yes, our cab services operate round the clock for airport transfers, local rides, and outstation journeys."
  },
  {
    question: "Do you offer corporate cab services in Pune?",
    answer: "Yes, we provide reliable transportation solutions for corporate employees, office meetings, business events, and company travel."
  },
  {
    question: "Can I book a cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "How can I book the best cab service in Pune with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ketan Jadhav",
    feedback: "Trustline Travels has been my first choice whenever I need a cab in Pune. The drivers are professional, the vehicles are well-maintained, and every trip has been comfortable and punctual.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Mehra",
    feedback: "From airport transfers to weekend outstation trips, Trustline Travels has always delivered excellent service. Their transparent pricing and courteous staff make them one of the best cab services in Pune.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/best-cab-service-in-pune.webp",
  "description": "Book the best cab service in Pune with Trustline Travels for safe, comfortable, and reliable travel. Get premium local, airport, and outstation taxi services including Pune to Mumbai cabs with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/best-cab-service-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Best Cab Service in Pune | Outstation & Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book the best cab service in Pune with Trustline Travels for airport transfers, outstation trips, and Pune to Mumbai taxi services. Enjoy reliable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs with 24x7 availability."
  />

  <meta
    name="keywords"
    content="Best cab service pune to mumbai, Best outstation cab service in pune, Best taxi service in pune, Best cab service from mumbai airport to pune, Best cab service mumbai to pune, Best cab service from pune to mumbai airport, Best mumbai pune cab service, best cab booking pune, best airport taxi pune, pune outstation taxi service, pune to mumbai cab service, mumbai to pune cab booking, reliable taxi service pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/60.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;